import React from 'react';
import Card from '../components/Card';
import { Heart } from 'lucide-react';
import type { WishlistItem } from '../types';

const wishlistItems: WishlistItem[] = [
    {
        id: '1',
        name: 'Professional Dashboard Template',
        type: 'template',
        price: 49.99,
        thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=300'
    },
    {
        id: '2',
        name: 'Icon Pack Bundle',
        type: 'asset',
        price: 24.99,
        thumbnail: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=300'
    },
];

export default function Wishlist() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Wishlist</h1>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {wishlistItems.map((item) => (
                    <Card key={item.id} className="relative group">
                        <div className="absolute top-4 right-4 z-10">
                            <button className="p-2 rounded-full bg-white shadow-md text-red-500 hover:text-red-600 transition-colors">
                                <Heart size={20} fill="currentColor" />
                            </button>
                        </div>
                        <div className="aspect-video rounded-lg overflow-hidden mb-4">
                            <img
                                src={item.thumbnail}
                                alt={item.name}
                                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300"
                            />
                        </div>
                        <div>
              <span className="text-sm font-medium text-navy-700 bg-blue-50 px-2 py-1 rounded">
                {item.type.charAt(0).toUpperCase() + item.type.slice(1)}
              </span>
                            <h3 className="mt-2 text-lg font-semibold text-gray-900">{item.name}</h3>
                            <p className="mt-1 text-lg font-bold text-navy-700">${item.price}</p>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}